import MembersUpcomingEvents from "../MembersUpcomingEvents";

export default function MembersUpcomingEventsTab() {
  return <MembersUpcomingEvents />;
}


